import { render } from "./EventList.vue?vue&type=template&id=ab539014&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ab539014&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ab539014"

export default script